import NamedDto from 'modules/base/dto/NamedDto';
import CaptchaTypeParametersEditDto from './CaptchaTypeParametersEditDto';

export class CaptchaTypeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.poolSize = null;
		/** @type {string} */
		this.engineName = null;
		/** @type {string} */
		this.engineParams = null;
		/** @type {string} */
		this.captchaFamily = null;
		/** @type {string} */
		this.status = null;
		/** @type {CaptchaTypeParametersEditDto} */
		this.parameters = null;
	}

	/**
	 * @typedef {Object} _CaptchaTypeEditDtoProps
	 * @property {number} poolSize
	 * @property {string} engineName
	 * @property {string} engineParams
	 * @property {string} captchaFamily
	 * @property {string} status
	 * @property {CaptchaTypeParametersEditDto} parameters
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaTypeEditDtoProps} CaptchaTypeEditDtoProps
	 */
	/**
	 *
	 * @param {CaptchaTypeEditDtoProps} props
	 * @returns {CaptchaTypeEditDto}
	 */
	setup(props) {
		super.setup(props);
		
		this.poolSize = props.poolSize;
		this.engineName = props.engineName;
		this.engineParams = props.engineParams;
		this.captchaFamily = props.captchaFamily;
		this.status = props.status;
		this.parameters = props.parameters !== null ? new CaptchaTypeParametersEditDto().setup(props.parameters) : new CaptchaTypeParametersEditDto();

		return this;
	}
}

export default CaptchaTypeEditDto;
